import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { companyList, getspotLightData, spotLightData } from '../../../redux/slices/spotlight';
import { companyLogoUpload } from '../../../redux/slices/users';
import { puzzleImage } from '../../../utilities/images';

const AddSpotlight = () => {

    const dispatch = useDispatch();
    const [logourl, setlogourl] = useState("");
    const [companyData, setcompanyData] = useState();

    console.log(logourl , "logourl")

    const [formData, setFormData] = useState({
        title: "",
        description: "",
        logo: "",
        companyid: ""
    });

    const handleChange = (e, fieldname) => {
        const { value, name } = e.target;
        setFormData({ ...formData, [name]: value });
    }

    const handleChangeIndustry = (id, flag) => {

        const selectedCompany = companyData.find((data) => data.user_id == id);
        setlogourl(selectedCompany?.company_logo)

        setFormData({
            ...formData,
            companyid: id
        })
        
    };

    const logoUpload = (e) => {
        const file = e.target.files[0];
        let params = {
            photo: file,
            type: "admin",
        };

        dispatch(
            companyLogoUpload({
                ...params,
                cb(res) {
                    console.log(res, "res")
                    if (res.status == 200 || res.status == 201) {
                        toast.success(`Background image uploaded successfully`);
                        setFormData((prev) => ({
                            ...prev,
                            logo: res?.data?.payload?.url,
                        }));
                    }
                },
            })
        );
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.companyid) {
            toast.error("Please select company");
            return
        }
        else if (!formData.title) {
            toast.error("Please add title");
            return
        }
        else if (!formData.description || formData.description.trim() === "") {
            toast.error("Please add description");
            return;
        } else if (!formData.logo) {
            toast.error("Please upload the background Image");
            return;
        }

        let params = {
            user_id: formData?.companyid,
            description: formData?.description,
            title: formData?.title,
            logo_image: formData?.logo
        }

        dispatch(
            getspotLightData({
                ...params,
                cb(res) {

                },
            })
        );

    }

    const getDefaultSpotLightData = () => {
        dispatch(
            spotLightData({
                cb(res) {
                    console.log(res, "fffffffff")
                    setFormData((prev) => ({
                        ...prev,
                        title: res?.data?.payload?.title || "",
                        description: res?.data?.payload?.description || "",
                        logo: res?.data?.payload?.logo_image || "",
                        companyid: res?.data?.payload?.user_id,
                    }));
                    setlogourl(res?.data?.payload?.user_details?.user_company_information?.company_logo)
                },
            })
        );
    };

    const getCompanyList = () => {
        dispatch(
            companyList({
                cb(res) {
                    setcompanyData(res?.data?.payload)
                },
            })
        );
    };

    useEffect(() => {
        getDefaultSpotLightData();
        getCompanyList();
    }, [])

    return (
        <>
            <div className='containerBox adminDashbord'>
                <div className='searchFilter'>
                    <h3 className='headTxtBlueSmall mb-3'>Member Spotlight</h3>
                </div>
                <form className='form mt-5' onSubmit={(e) => handleSubmit(e)}>
                    <div className='row'>

                        <div className="form-group col-md-6 mb-3">
                            <label for="" className='customLabel'>Select Company
                                <span className='fieldMandatory'>*</span></label>
                            <select
                                className="cateSelectbox"
                                name='companyid'
                                required=""
                                value={formData.companyid}
                                onChange={(e) => {
                                    handleChangeIndustry(e.target.value);
                                }}
                            >
                                <option value="">
                                    Select Company
                                </option>
                                {companyData?.length > 0 ? (
                                    <>
                                        {companyData?.map((data) => {
                                            return (
                                                <option value={data?.user_id}>
                                                    {data?.company_name}
                                                </option>
                                            );
                                        })}
                                    </>
                                ) : (
                                    ""
                                )}
                            </select>
                        </div>


                        <div className="form-group col-md-6 mb-3">
                            <label for="" className='customLabel'>Spotlight Title
                                <span className='fieldMandatory'>*</span></label>
                            <input
                                name="title"
                                type="text"
                                className="customFormControl"
                                value={formData.title}
                                placeholder="Spotlight Title"
                                onChange={(e) => handleChange(e)}
                            />
                        </div>


                        <div className="form-group col-md-6 mb-3">
                            <label for="" className='customLabel'>Spotlight Description
                                <span className='fieldMandatory'>*</span></label>
                            <textarea
                                name="description"
                                className="customFormControl"
                                value={formData.description}
                                placeholder="Spotlight Description"
                                rows={4}
                                onChange={(e) => handleChange(e)}
                            >
                            </textarea>
                        </div>

                        <div className="mb-3 col-md-6">
                            <h3 for="" className='customLabel'>
                                Company Logo
                            </h3>
                            <img
                                src={logourl ? logourl : puzzleImage}
                                alt="Spotlight Logo"
                                className="img-thumbnail"
                                style={{ width: '120px', height: '120px', objectFit: 'cover' }} />
                        </div>
                    </div>

                    <div className="form-group mb-3">
                        <label for="" className='customLabel'>Background Image
                            <span className='fieldMandatory'>*</span></label>
                        {formData.logo && (
                            <div className="mb-2">
                                <img
                                    src={formData.logo}
                                    alt="Spotlight Logo"
                                    className="img-thumbnail"
                                    style={{ width: '200px', height: '200px', objectFit: 'cover' }} />
                            </div>
                        )}
                        <label className="custom-file-upload">
                            <input
                                type="file"
                                name="logo"
                                onChange={logoUpload}
                                accept=".jpg,.png,.jpeg"
                                style={{ display: 'none' }} // Hide default input
                            />
                            <span className="image-upload">Upload Image</span>
                        </label>
                    </div>




                    <div className='col-12 text-end mt-5'>
                        <button className='submitBtn  mt-2 d-inline' type="submit">
                            {/* {userSelector?.loading && (
                                <span className="spinner-border spinner-border-sm"></span>
                            )} */}
                            Submit
                        </button>
                    </div>

                </form>
            </div>

        </>
    )
}

export default AddSpotlight;